// extracted by css-extract-rspack-plugin
export default {"button":"_7bb23352","arrow":"_19999c5d","expanded":"_c09dce03"};